<template>
  <component :tickets="tickets" :layout="layout" :is="tableComponent" />
</template>

<script>
  import { mapState } from 'vuex'
  import TableSimple from '@/components/table/TableSimple'
  import TableCols from '@/components/table/TableCols'
  import { layouts, colorSchemes } from '@/app/const/settings'
  import TableState from '@/components/table/TableState.vue'
  import BauTable from '@/components/table/BauTable.vue'
  import TableAd from '@/components/table/TableAd.vue'
  import TableVerticalAd from '@/components/table/TableVerticalAd.vue'
  import TableDiffClients from '@/components/table/TableDiffClients.vue'
  import ClientsQueue from '@/app/model/clients/clients-queue'

  export default {
    name: 'TableManager',
    props: {
      tickets: {
        type: [Array, ClientsQueue]
      }
    },
    computed: {
      ...mapState({
        guiSettings: state => state.gui.settings
      }),
      layout () {
        return this.guiSettings.layout.code
      },
      colorScheme () {
        return this.guiSettings.colorScheme
      },
      tableComponent () {
          switch (this.layout) {
              case layouts.default:
                  return TableSimple
              case layouts.col2:
              case layouts.col3:
                  return TableCols
              case layouts.colAd:
                  return TableAd
              case layouts.col2State:
                  if (this.colorScheme.code === colorSchemes.baucenter) {
                      return BauTable
                  }
                  return TableState
              case layouts.col2DiffClients:
                  return TableDiffClients
              case layouts.col1Ad:
              case layouts.col2Ad:
                  return TableVerticalAd
              default:
                  return undefined
          }
      }
    }
  }
</script>
